export enum LOCATION_SEARCH_OBJECT_SORT_KEYS {
  sortOrder = 'sortOrder',
  sortedBy = 'sortedBy'
}